// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.caret {
  cursor: pointer;
  -webkit-user-select: none; /* Safari 3.1+ */ /* Firefox 2+ */ /* IE 10+ */
  user-select: none;
}

.caret::before {
  content: "▶";
  color: black;
  display: inline-block;
  margin-right: 6px;
}

.caret-down::before { /* IE 9 */ /* Safari */
  transform: rotate(90deg);
}

.nested {
  display: none;
}

.active {
  display: block;
}

.row-detail {
  margin-left: 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/row-detail/row-detail.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,eAAA;EACA,yBAAA,EAAA,gBAAA,EACA,eAAA,EACA,WAAA;EACA,iBAAA;AAEF;;AACA;EACE,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;AAEF;;AACA,sBACE,SAAA,EACA,WAAA;EACA,wBAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,iBAAA;AAEF","sourcesContent":[".caret {\n  cursor: pointer;\n  -webkit-user-select: none; /* Safari 3.1+ */\n  -moz-user-select: none; /* Firefox 2+ */\n  -ms-user-select: none; /* IE 10+ */\n  user-select: none;\n}\n\n.caret::before {\n  content: \"\\25B6\";\n  color: black;\n  display: inline-block;\n  margin-right: 6px;\n}\n\n.caret-down::before {\n  -ms-transform: rotate(90deg); /* IE 9 */\n  -webkit-transform: rotate(90deg); /* Safari */\n  transform: rotate(90deg);\n}\n\n.nested {\n  display: none;\n}\n\n.active {\n  display: block;\n}\n\n.row-detail {\n  margin-left: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
